import { NgModule } from '@angular/core';
import { AppConfigService } from '@services/config.service';
import { AbstractSecurityStorage, AuthModule, DefaultLocalStorageService, LogLevel, OpenIdConfiguration, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';

export const httpLoaderFactory = (configSvc: AppConfigService): StsConfigLoader => {
    const config: OpenIdConfiguration = {
        authority: configSvc.get<string>(x => x.oauth.authority),
        redirectUrl: configSvc.get<string>(x => x.oauth.redirectUrl),
        postLogoutRedirectUri: configSvc.get<string>(x => x.oauth.postLogoutRedirectUri),
        clientId: configSvc.get<string>(x => x.oauth.clientId),
        scope: configSvc.get<string>(x => x.oauth.scope),
        responseType: configSvc.get<string>(x => x.oauth.responseType),
        historyCleanupOff: true,
        silentRenew: true,
        useRefreshToken: configSvc.get<boolean>(x => x.oauth.useRefreshToken),
        logLevel: LogLevel.Warn,
        renewTimeBeforeTokenExpiresInSeconds: 30
    };

    return new StsConfigStaticLoader(config);
};

@NgModule({
    imports: [
        AuthModule.forRoot({
            loader: {
                provide: StsConfigLoader,
                useFactory: httpLoaderFactory,
                deps: [AppConfigService]
            }
        }),
    ],
    exports: [AuthModule],
    providers: [
        {
            provide: AbstractSecurityStorage,
            useClass: DefaultLocalStorageService,
        },
    ],
})
export class AuthConfigModule { }
